import { createFileRoute } from "@tanstack/react-router";
import { PostOpInstructions } from "@/components/site/PostOpInstructions";

export const Route = createFileRoute("/dayof_sms-2")({
  head: () => ({
    meta: [
      { title: "SMS – Day Of Procedure - Restore Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair post-operative instructions: pain management, ATP spray, icing, swelling, washing, exercise and regrowth timeline after your FUE hair transplant.",
      },
      { property: "og:title", content: "Post-Operative Instructions | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "Day-by-day aftercare instructions for RESTORE® Hair patients following an FUE hair transplant procedure.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/dayof_sms-2/" }],
  }),
  component: () => <PostOpInstructions />,
});
